/** @format */

import {PaymentProfilesList} from './payment_profiles_list/payment_profiles_list';
import {PaymentsProvider, usePaymentsContext} from './payments_context_provider';
import {Loading} from 'frontier-utilities';
import {If} from 'frontier-utilities';
import {Link} from 'react-router-dom';
import React from 'react';

// styles
import './container.scss';

const Container = () => {
    const {state} = usePaymentsContext();

    const hasPaymentMethods = state.paymentProfiles.length > 0;

    if (state.loading) {
        return <Loading message="Loading Payment Methods..." />;
    }

    return (
        <div className="payment-form-93ht">
            <div className="payment-form-93ht__header d-flex align-items-center justify-content-between mb-4">
                <h3 className="m-0 p-0">Recently Used Payment Methods</h3>

                <Link to="/account/users/payments/add">
                    <button className="btn btn--secondary">
                        <b>
                            {hasPaymentMethods
                                ? 'View & Add New Payment Methods' // change this to View & Edit All Payment Methods once editing is enabled
                                : 'Add New Payment Method'}
                        </b>
                    </button>
                </Link>
            </div>
            <If condition={!hasPaymentMethods}>
                <div className="alert alert-info">No payment methods added yet!</div>
            </If>
            <If condition={hasPaymentMethods}>
                <PaymentProfilesList paymentProfiles={state.paymentProfiles} />
            </If>
        </div>
    );
};

export const UserPaymentMethods = () => {
    return (
        <PaymentsProvider>
            <Container />
        </PaymentsProvider>
    );
};
